import { render } from "./articleDetail.vue?vue&type=template&id=2167d0d8&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=2167d0d8&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2167d0d8"]])

export default __exports__